import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import Footer from "../footer/footer.jsx"
function Content() {
	return (
		<AppSettings.Consumer>
			{({ appContentClass }) => (
				<div className={'app-content ' + appContentClass} data-scrollbar="true" data-height="100%">
					<Outlet />
					<Footer />
				</div>
			)
			}
		</AppSettings.Consumer>
	)
}

export default Content;
